import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { ApiV6Service } from '@service/apiv6.service';
import { Router } from '@angular/router';
import { forkJoin, from, lastValueFrom, of, catchError, map} from 'rxjs';
import { MenuServiceInt } from '@core/_services/menu.serviceint';
import { EditorService } from '@service/editor.service';
import { MessagesService } from '@core/_services/messages.service';
import { AuthService } from '@auth/auth.service';
import { DisplayResultComponent } from '@documalis/displayresult';
import {
    formatRequestIndex,
    setinfoList,
    currentRequest,
    setCurrentRequest,
    getlistColumns,
    getEmptyField,
    setResult,
    decodeUtf8,
    setArrayAllBasket,
    encodeUtf8,
    setFormatList,
    RequestItem,
    getOperator,
    setCriteriaItem,
    getInternalPrefUsr,
    findItem,
} from '@core/_utils/tools.utils';
import { ParamUrlService } from '@service/paramurl.service';
import { Tools } from '@service/tools';
import { CheckTools } from '@service/check.tools';
import {
    doc_atfcount,
    doc_name,
    doc_creationdate,
    doc_path,
    doc_page,
    reqIdx,
    FetchValue,
    doc_root,
    doc_ext,
    KeyDetailDocks,
    filterFormaList,
} from '@documalis/_const/const';
import { CommonService } from '@service/common.service';
import { LayoutService } from '../../layout/service/app.layout.service';
import { TranslateService } from '@ngx-translate/core';
import { TreeService } from '@service/tree.service';
import { prepareDate, verifyPeriod } from '@core/_utils/date.utils';

@Component({
    selector: 'page-request-list',
    styleUrls: ['./page-request-list.component.scss'],
    templateUrl: './page-request-list.component.html',
})
export class PageRequestListComponent implements OnInit {
    public srchMode = reqIdx;
    public listRequest: any;
    public listResult: any;
    public Title: string;
    public variableList: any[];
    public currentLabelRequest: string;
    public selectedResults: any[any];
    public listDefault: any[];
    public VariableList: any[];
    public resultList: any[];
    public infoList: any[];
    public isAdmin = false;
    public currentIdRequest: number;
    public index: number;
    public listColumns: any[];
    public displayCriteria = false;
    public displayListResult = false;
    public displaySearch = false;
    public currentRequest: currentRequest;
    public resultDisplay: any;
    public resultRequest: any;
    public curPage: number;
    public nbDoc: number;
    public isDesktop: boolean = false;
    public crit = 'crit';
    public retlst = 'retlst';
    public retDash: boolean = false;
    public retTipLib: string;
    public listReqSys: any;
    public autoDocId: string;
    private emptyField: boolean = true;
    public allowRequest: boolean = false;
    public allowFullText: boolean = false;
    public offSet: number = 0;
    public fetch: number = 0;
    public fetchParam: any;

    public checkFilter = false;
    public searchPath = '';
    public updatePath = '';
    public testPath = '';
    private rootPath: {
        root: string;
        path: string;
    };
    public isExpanded = false;
    public blockedTree: boolean = false;
    public loadTree = false;
    public resultTree;
    public treeIndex;
    public formatType = '';
    public formatList: any[];
    public dateBegin: Date;
    public dateEnd: Date;
    public filterState: {
        state: boolean;
        message: string;
    };
    private internalPrefUsr: any;

    @ViewChild('dispresult') public dispResult: DisplayResultComponent;
    @ViewChild('critElem') critElem: ElementRef;
    @ViewChild('retElem') retElem: ElementRef;

    public visibleCount: boolean = false;
    public nbDocCount: number = 0;

    constructor(
        protected _messageService: MessagesService,
        private api: ApiV6Service,
        private _router: Router,
        public menu: MenuServiceInt,
        public editorService: EditorService,
        private auth: AuthService,
        private paramUrlService: ParamUrlService,
        private tools: Tools,
        private checkTools: CheckTools,
        private commonService: CommonService,
        private main: LayoutService,
        private translate: TranslateService,
        private treeService: TreeService,
    ) {
        this.index = 0;
        this.menu.display = true;
        this.isDesktop = this.main.isDesktop();
        this.isAdmin = this.auth.isAdmin();

        this.VariableList = [];
        this.resultList = [];
        this.formatList = [];
        this.setResultList();
        this.fetchParam = {page: 1, displayNext: false};
        this.fetch = FetchValue;
        this.dateBegin = undefined;
        this.dateEnd = undefined;
        this.formatType = '';
    }

    public ngOnInit() {
        this.Title = this.translate.instant('Query_List_1');
        this.retDash = false;
        this.retTipLib = this.translate.instant('Return_Que');
        this.autoDocId = '';
        this.internalPrefUsr = getInternalPrefUsr();
        return from(this.menu.getMenu()).pipe(
            map(result => {
                this.allowRequest = this.menu.allowRequest;
                this.allowFullText = this.menu.allowFullText;
                this.getRequestList();
                this.currentIdRequest = -1;
                this.emptyField = true;
                this.commonService.checkReset();
                this.initOffSet();
             }),
            catchError((error: any) => {
                console.log(error);
                return of(null);
            })).subscribe();
    }

    public ngOnDestroy() {
        this.fetchParam = null;
    }

    private init() {
        this.listRequest = null;
        this.variableList = null;
        this.listReqSys = null;
    }

    private async getRequestList() {
        let wRes: any;
        try {
            wRes = await lastValueFrom(this.getRequestData());      
        } catch (error) {
            console.log('Error', error);
            this._messageService.addErrorMsg(this.translate.instant('Load_Data_KO'));
            return;
        }
        this.init();
        this.autoDocId = '';
        this.listRequest = this.setPref(this.getNoBsk(wRes.getRequestList.data, 'webReqDetails'), wRes.getUsedRequest.data);
        this.listReqSys = wRes.getRequestSys.data;
        this.listResult = [...this.getDefDisplay()];
        this.listResult = this.listResult.concat(this.getNoBsk(wRes.getResultList.data, 'webResultDetails'));
        this.editorService.setCustomEditorList(wRes.getEditorList.CustomEditorList);
        this.tools.setDocks(KeyDetailDocks, wRes.getDocks, '');        
        this.formatList = setFormatList(filterFormaList);
        if (this.paramUrlService.requestName !== '') {
            this.menu.updateRestrited(this.paramUrlService.restricted);                    
            if (this.paramUrlService.isReqSys === false) {
                this.execAuto();
            } else {
                this.retDash = true;
                this.retTipLib = this.translate.instant('Return');
                this.execAutoSys();
            }
        } else {
            this.execFirstRequest();
        }
    }

    private getNoBsk(aList, aName) {
        let warray = [];
        aList.forEach(item => {
            if (this.bskReq(item[aName]) === false) {
                warray.push(item);
            }
        });
        return warray;
    }

    private bskReq(aData) {
        for (const item of aData) {
            if (item.name.substring(0, 5) === '&bsk_') {
                return true;
            }
        };
        return false;
    }

    private setPref(aRequestList, aUsedRequest) {
        let warray = [];
        let wIndex = -1;
        if (this.internalPrefUsr.requestOrder === true) {
            return aRequestList;
        }
        aUsedRequest.forEach((item) => {
            wIndex = findItem(aRequestList, item.idRequest, 'id');
            if (wIndex !== -1) {
                warray.push(aRequestList[wIndex]);
                aRequestList.splice(wIndex, 1);
            }
        });
        warray = warray.concat(aRequestList);
        return JSON.parse(JSON.stringify(warray));
    }

    private getDefDisplay() {
        let warray = [];
        warray.push({ id: null, label: this.translate.instant('Def_Dis'), visibility: 0 });
        return warray;
    }

    private getRequestData() {
        return forkJoin([
            this.api.getCustomEditorlist(),
            this.api.getRequestPrepare('getrequestsbyuser', ''),
            this.api.execUrlAction('getresultsbyuser',''),
            this.api.execUrlAction('getusedrequests', ''),
            this.api.getRequestPrepare('getrequestssys', ''),
            this.api.execUrlAction('getdocksbasket',{name: KeyDetailDocks}),
        ]).pipe(
            map(([getEditorList, getRequestList, getResultList, getUsedRequest, getRequestSys, getDocks]) => {
                return { getEditorList, getRequestList, getResultList, getUsedRequest, getRequestSys, getDocks };
            })
        );
    }

    private execFirstRequest() {
        if (this.listRequest.length > 0) {
            this.prepareSetClick(this.listRequest[0].value);
        }
    }

    // exécution automatique (url)
    private execAuto() {
        let wIndex = -1;
        wIndex = findItem(this.listRequest, this.paramUrlService.requestName, 'label');
        if (wIndex !== -1) {
            this.listRequest[wIndex];
            this.setClick(this.listRequest[wIndex].id, wIndex);
            this.prepareClick(wIndex);
        }
    }

    private execAutoSys() {
        let wIndex = -1;
        wIndex = findItem(this.listReqSys, this.paramUrlService.requestName, 'label');
        if (wIndex !== -1) {
            this.setVariableList(this.listReqSys[wIndex].webReqDetails);
            this.selectedResults = [];
            this.autoDocId = this.paramUrlService.doc_docid;
            this.prepareClick(wIndex);
        } else {
            this._messageService.addErrorMsg(this.translate.instant('Query_3_Req', {name: this.paramUrlService.requestName}));
            this.paramUrlService.clear();
        }
    }

    private prepareClick(aIndex) {
        let wIndex = -1;
        try {
            if (this.paramUrlService.requestParamToUse !== null) {
                this.paramUrlService.setParamsToUse(this.listRequest[aIndex].webReqDetails);
                this.setVariableList(this.listRequest[aIndex].webReqDetails);
                wIndex = this.getIndexResult(this.paramUrlService.requestParamToUse.idresult);
                this.selectedResults = this.getSelectResult(this.listResult, wIndex);
            } else {
                this.paramUrlService.setParamsIndex(this.variableList);
            }            
            this.editorService.updateVariable(this.variableList, true);
            this.onClickExec('', false);
        } finally {
            this.paramUrlService.clear();
        }
    }

    // click sur une requête
    public onClick($event) {
        if ($event.value !== null) {
            this.prepareSetClick($event.value);
        }
    }

    // Tree
    public nodeSelect(event) {
        this.searchPath = this.treeService.getPathClick(event.node, '');
        this.updatePath = this.searchPath;
        this.searchPath = encodeUtf8(this.searchPath);
        this.rootPath = this.treeService.getRootPath(this.updatePath);
        this.testPath = '';
        this.isExpanded = true;
        this.checkFilter = true;
    }

    public async nodeExpand(event) {
        let wRes;
        wRes = await this.treeService.nodeExpand(event, (callBack) => {
            this.blockedTree = callBack;
        });
    }

    public async onChangeCkFilter($event) {
        if (this.loadTree === false) {
            await this.getLoadTree();
        }
        if (!$event.checked) {
            this.rootPath = this.treeService.initRootPath();
        } else {
            this.rootPath = this.treeService.getRootPath(this.updatePath);
        }
    }

    private async getLoadTree() {
        let wRes: any;
        wRes = await this.treeService.getLoadTree();
        if (this.treeService.requestFailed === true) {
            return;
        }
        this.resultTree = wRes.base.result;
        this.treeIndex = this.treeService.updateTreeSearch(this.resultTree);
        this.loadTree = true;
    }

    private getIndexResult(aId) {
        let wRes : any = null;
        if (aId !== null) {
            wRes = Number(aId);
        } 
        return wRes;
    }

    // Lecture des paramètres de la requête
    private prepareSetClick(aId) {
        let wIndex = -1;
        wIndex = findItem(this.listRequest, aId, 'id');
        if (wIndex !== -1) {
            this.setClick(aId, wIndex);
        }
    }

    private setClick(aId, aIndex) {
        if (this.isDesktop === false) {
            setTimeout(() => {
                this.critElem.nativeElement.click();
            }, 100);
            this.retElem.nativeElement.click();
        }
        this.currentIdRequest = aId;
        this.currentLabelRequest = this.listRequest[aIndex].label;
        this.emptyField = getEmptyField(this.listRequest[aIndex].emptyfield);
        this.selectedResults = [];
        this.setVariableList(this.listRequest[aIndex].webReqDetails);
        this.selectedResults = this.getSelectResult(this.listResult, this.listRequest[aIndex].idResult);
    }

    private setVariableList(aList) {
        this.variableList = null;
        this.variableList = aList;
        this.execParse();
        // A activer pour index dynamique
        this.setListVar(aList);
    }

    private execParse() {
        let wValue = '';
        this.editorService.variableListService.parseService.setBasketName('');
        this.variableList.map(item => {
                wValue = decodeUtf8(this.editorService.variableListService.parseService.execParse(item.DefaultValue));
                item.DefaultValue = wValue;
                item.valdefault = wValue;
                item.value = wValue;
                return item;  
            }
        );
    }

    // Affichage des index dynamique.
    // Reste à faire : gestion retour (variable) après exécution requête
    private setListVar(aList) {
        let wVarList: any;
        let wVar = [];
        let wItem = {};
        aList.forEach((item) => {
            (wItem = {
                Forced: 'false',
                Hidden: item.visible === 0 ? 'true' : 'false',
                Label: item.Label,
                Name: item.name,
                ReadOnly: 'false',
                Required: 'false',
                Type: item.type,
                DefaultValue: item.DefaultValue,
                EditorName: item.type,
                System: item.name.substring(0, 4) === 'sys_' ? 'true' : 'false',
                operator: item.operator,
                displaydefault: item.displaydefault,
            });
            wVar.push(wItem);
        });
        wVarList = {
            VariableList: {
                Variable: wVar,
            },
        };
        this.editorService.setMode(true);
        this.editorService.variableListService.parseService.setBasketName('');
        // variableList va contenir le type d'éditeur et les combos chargées
        this.variableList = JSON.parse(
            JSON.stringify(this.editorService.formatVarList(this.editorService.variableListService.execParse(wVarList)))
        );
    }

    private getSelectResult(alistResult, aId) {
        let wArray = [];
        let wRes = null;
        wArray = alistResult.filter((item) => {
            return item.id === aId;
        });
        if (wArray.length === 0) {
            wRes = alistResult[0];
        } else {
            wRes = wArray[0];
        }
        return wRes;
    }

    // Add a request
    public AddRequest() {
        this._router.navigate(['./requests']);
    }

    public onCountDoc($event: any) {
        this.visibleCount = false;
        this.nbDocCount = 0;
        if ($event === 'execute') {
            this.onClickExec('', false);
        }
    }

    public async onClickCount() {
        let wRes: any;
        if (this.verifyParams() === false) {
            return;
        }     
        const wParams = this.initSearch(true, '');
        try {            
            wRes = await lastValueFrom(this.api.execUrlAction('execrequestsearch', wParams.request));
            this.checkTools.checkError(wRes);
            if (this.checkTools.getRes() === true) {
                if (wRes.DocCount === undefined || wRes.DocCount === null) {
                    this._messageService.addErrorMsg(this.translate.instant('Err_Doc_Num'));
                } else {
                    this.visibleCount = true;
                    this.nbDocCount = wRes.DocCount;
                }
            } else {
                this._messageService.addErrorMsg(this.checkTools.getMsg());
            }
        } catch (error) {
            console.log('Error', error);
            this._messageService.addErrorMsg(this.translate.instant('Load_Data_KO'));
        }
    }

    public async onClickExec(aSearchWord, aNext) {
        let wRes: any;
        let wCheck: any;
        let wMsg: string;
        if (this.verifyParams() === false) {
            return;
        }     
        this.fetchParam.displayNext = true;
        if (aNext === false) {
            this.initExecSearch();
            wMsg = this.translate.instant('Find_0');
        } else {
            wMsg = this.translate.instant('Find_End');
        }
        const wParams = this.initSearch(false, aSearchWord);
        this.currentRequest = setCurrentRequest(reqIdx, wParams.request);
        this.listColumns = getlistColumns(this.resultList, this.translate);
        try {
            wRes = await lastValueFrom(this.api.execUrlAction('execrequestsearch', wParams.request));
            wCheck = this.tools.checkResult(wRes, reqIdx, wMsg);
            this.resultRequest = wCheck.resultRequest;
            if (aNext === true) {
                if (Number(this.resultRequest.DocCount) !== 0) {
                    setArrayAllBasket(this.resultDisplay, this.tools.formatDisplayDate(wCheck.resultDisplay, this.listColumns));
                    this.setResultValue(wCheck);
                    this.dispResult.setTotalDoc(this.nbDoc);
                } else {
                    this.fetchParam.displayNext = false;      
                }
            } else {                
                this.resultDisplay = this.tools.formatDisplayDate(wCheck.resultDisplay, this.listColumns);
                this.setResultValue(wCheck);
                if (Number(this.resultRequest.DocCount) < FetchValue) {
                    this.fetchParam.displayNext = false;  
                }
            }
            this.filterState = this.tools.getFilterState(this.resultRequest.DocCount, aSearchWord);
            this.displayListResult = false;
            this.fetchParam.page = this.curPage;                                
        } catch (error) {
            console.log('Error', error);
            this.index = 0;
            this.initOffSet();
            this._messageService.addErrorMsg(this.translate.instant('Load_Data_KO'));
        } finally {
            // 
        }
    }

    private verifyParams() {
        let wRes = true;
        if (verifyPeriod(this.dateBegin, this.dateEnd) === false) {
            this._messageService.addWarnNoStick(this.translate.instant('Date_KO'));
            wRes = false;
        }
        if (this.checkFilter && this.searchPath === '') {
            this._messageService.addWarnNoStick(this.translate.instant('Path_Fil'));
            wRes = false;
        }
        return wRes;
    }

    private initExecSearch() {
        this.resultDisplay = [];
        this.listColumns = [];
        this.infoList = [];
        this.nbDoc = 0;
        this.curPage = 0;
    }

    private initOffSet() {
        this.offSet = 0;
        this.fetch = FetchValue;
    }

    private setResultValue(wCheck) {
        this.curPage = this.curPage + wCheck.curPage;
        this.nbDoc = this.nbDoc + Number(wCheck.nbDoc);
        this.index = wCheck.index; 
        this.displayCriteria = wCheck.displayCriteria;
    }

    private initSearch(aCount, aSearchWord) {
        let wRequest = new Array();
        let wSearch = {
            paramsOk: false,
            request: <any>{},
        };
        this.prepareDataReq();
        this.updateResultList(this.selectedResults, this.listDefault);
        wSearch.paramsOk = true;
        wSearch.request = formatRequestIndex(
            this.editorService,
            this.VariableList,
            this.resultList,
            aCount,
            this.currentIdRequest,
            this.selectedResults.id,
            this.emptyField,
            aSearchWord,
            this.offSet,
            this.fetch
        );
        wRequest = this.addFilterComp();
        wSearch.request.Search.CriteriaList = wSearch.request.Search.CriteriaList.concat(wRequest);
        return wSearch;
    }

    private addFilterComp() {
        let wRequest = new Array();
        let wRequestItem: RequestItem;
        let wDate: string;
        wDate = prepareDate(this.dateBegin, false);
        if (wDate !== '') {
            wRequestItem = setCriteriaItem(doc_creationdate, getOperator(9), wDate);
            wRequest.push(wRequestItem);            
        }
        wDate = prepareDate(this.dateEnd, true);
        if (wDate !== '') {
            wRequestItem = setCriteriaItem(doc_creationdate, getOperator(8), wDate);
            wRequest.push(wRequestItem);       
        }
        if (this.checkFilter === true) {
            if (this.rootPath.root !== '') {
                wRequestItem = setCriteriaItem(doc_root, getOperator(0), this.rootPath.root);
                wRequest.push(wRequestItem);       
            }
            if (this.rootPath.path !== '') {
                wRequestItem = setCriteriaItem(doc_path, getOperator(0), this.rootPath.path);
                wRequest.push(wRequestItem);       
            }            
        }
        if (this.formatType !== '') {
            wRequestItem = setCriteriaItem(doc_ext, 0, this.formatType);
            wRequest.push(wRequestItem);       
        }
        return wRequest;
    }

    private updateResultList(aData, aListDefault) {
        if (aData.id === null || aData.id === undefined) {
            this.setResultList();
            this.setResultDefault(aListDefault);
        } else {
            this.resultList = [];
            setResult(this.resultList, doc_atfcount, this.translate);
            this.setResultSelected(aData);
        }
        this.infoList = setinfoList(this.resultList);
        if (this.infoList.length === 0) {
            setResult(this.infoList, doc_name, this.translate);
            this.infoList[0].thumbinfo = 1;
        }
    }

    private setResultDefault(aVariableList) {
        aVariableList.forEach((item) => {
            this.resultList.push({
                name: item.name,
                type: item.type,
                label: this.getItemLabel(item),
                sort: -1,
                typeorder: 0,
                thumbinfo: item.thumbinfo,
            });
        });
    }

    private getItemLabel(aItem) {
        if (aItem.name.substring(0,1) !== '&') {
            return aItem.Label;
        } else {
            return this.translate.instant(aItem.name);
        }
    }

    private setResultSelected(aData) {
        let windex = -1;
        if (aData === undefined) {
            return;
        }
        if (aData.webResultDetails === undefined) {
            return;
        }
        aData.webResultDetails.map((elem) => {
            windex = -1;
            windex = this.resultList.findIndex((item) => {
                return item.name === elem.name;
            });
            if (windex === -1) {
                this.resultList.push({
                    name: elem.name,
                    type: elem.type,
                    label: elem.label,
                    sort: elem.numorder,
                    typeorder: elem.typeorder,
                    thumbinfo: elem.thumbinfo,
                });
            } else {
                this.resultList[windex].sort = elem.numorder;
                this.resultList[windex].typeorder = elem.typeorder;
                this.resultList[windex].thumbinfo = elem.thumbinfo;
            }
        });
    }

    private setResultList() {
        this.resultList = [];
        setResult(this.resultList, doc_atfcount, this.translate);
        setResult(this.resultList, doc_name, this.translate);
        setResult(this.resultList, doc_creationdate, this.translate);
        setResult(this.resultList, doc_path, this.translate);
        setResult(this.resultList, doc_page, this.translate);
    }

    private prepareDataReq() {
        this.setResultList();
        // A activer pour index dynamique
        this.variableList = this.editorService.setValueForUpdate(this.variableList);
        this.VariableList = [...this.editorService.upateListVariable(this.variableList)];
        this.listDefault = [...this.editorService.addDefaultDisplay(this.variableList)];
        this.updateDate(this.VariableList, this.variableList);
    }

    private updateDate(aArraySrc, aArrayDst) {
        for (let index = 0; index < aArraySrc.length; index++) {
            if (aArraySrc[index].type === 'DateTime') {
                aArrayDst[index].value = aArraySrc[index].value;
                aArrayDst[index].DefaultValue = aArraySrc[index].DefaultValue;
            }
        }
    }

    public returnList() {
        this.displayListResult = false;
        this.dispResult.goResultDoc();
    }

    public returnCriteria() {
        if (this.retDash === true) {
            this._router.navigate(['dashboard']);
        } else {
            this.index = 0;
            this.initOffSet();
        }
    } 

    public onReturnResult(event) {
        if (event === 'empty') {
            this.returnCriteria();
        } else {
            this.displayListResult = true;
        }
    }

    public onFilterSearch() {
        this.displaySearch = true;
    }

    public closeSearch() {
        this.displaySearch = false;
    }

    public onClickSearch($event) {
        this.displaySearch = false;
        this.initOffSet();
        this.onClickExec($event.searchText, false);
    }

    public onAction(event) {
        if (event === 'move') {
            this.returnList();
        }
    }

    public onNextDocs() {
        this.offSet = this.offSet + this.fetch;
        this.fetch = FetchValue;
        this.onClickExec('', true);
    }
}
